/** Cinematic glass UI — current default instance theme. */
export const PREMIUM_APP_THEME = {
    id: 'premium',
    name: 'Premium',
    description: 'Deep cinematic panels, violet accents, and ambient lighting.',
    typography: {
        fontFamily: [
            'Inter',
            'ui-sans-serif',
            'system-ui',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            'sans-serif',
        ],
        googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
    },
    layout: {
        appShellPadding: '1rem',
        appShellGap: '1rem',
        panelBorderRadius: '20px',
        channelSidebarWidth: '20rem',
        channelHeaderHeight: '4.5rem',
        composerBorderRadius: '18px',
    },
    colors: {
        base: {
            deepest: '#08090D',
            deep: '#0B0D12',
            DEFAULT: '#0F1118',
        },
        brand: {
            50: '#f5f3ff',
            100: '#ede9fe',
            200: '#ddd6fe',
            300: '#c4b5fd',
            400: '#a78bfa',
            500: '#8B5CF6',
            600: '#7c3aed',
            700: '#6d28d9',
            800: '#5b21b6',
            900: '#4c1d95',
        },
        accent: {
            violet: '#8B5CF6',
            purple: '#A855F7',
            blue: '#3B82F6',
            cyan: '#06B6D4',
        },
        surface: {
            900: '#08090D',
            800: '#0F1118',
            700: '#11141D',
            600: '#151923',
            500: '#1A1F2B',
            400: '#252b3a',
        },
    },
    borders: {
        subtle: 'rgba(255, 255, 255, 0.06)',
        medium: 'rgba(255, 255, 255, 0.08)',
        strong: 'rgba(255, 255, 255, 0.12)',
    },
    shadows: {
        panel: '0 0 0 1px rgba(255,255,255,0.03), 0 24px 64px rgba(0,0,0,0.4)',
        glowViolet: '0 8px 32px rgba(139, 92, 246, 0.12)',
        glowBlue: '0 8px 32px rgba(59, 130, 246, 0.1)',
        appShell: '0 0 0 1px rgba(255, 255, 255, 0.03), 0 30px 80px rgba(0, 0, 0, 0.45)',
        channelRowActive: '0 0 0 1px rgba(139, 92, 246, 0.12), 0 4px 24px rgba(139, 92, 246, 0.08)',
        composerFocus: '0 0 0 1px rgba(139, 92, 246, 0.15), 0 12px 40px rgba(59, 130, 246, 0.12)',
        depthPanel: '0 0 0 1px rgba(255,255,255,0.04), 0 8px 32px rgba(0,0,0,0.38), 0 24px 64px rgba(0,0,0,0.28)',
        depthButton: '0 2px 10px rgba(0,0,0,0.28), 0 6px 18px rgba(0,0,0,0.16)',
        depthControl: '0 2px 12px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.05)',
    },
    effects: {
        ambientOrbBlur: '120px',
        ambientOrbOpacity: 0.15,
        ambient: {
            violet: '#8b5cf6',
            purple: '#a855f7',
            blue: '#3b82f6',
            cyan: '#06b6d4',
        },
        scrollbarThumb: 'rgba(255, 255, 255, 0.08)',
        scrollbarThumbHover: 'rgba(255, 255, 255, 0.14)',
        premiumTransitionMs: 180,
    },
    gradients: {
        serverBannerOverlay: 'linear-gradient(180deg, rgba(8, 9, 13, 0.15) 0%, rgba(8, 9, 13, 0.55) 55%, rgba(15, 17, 24, 0.98) 100%)',
        serverBannerGlow: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(139, 92, 246, 0.22) 0%, transparent 70%)',
        composerGlow: 'linear-gradient(90deg, rgba(139, 92, 246, 0.35), rgba(59, 130, 246, 0.3))',
    },
    chrome: {
        enableAmbientLights: true,
        enableAppShellBorder: true,
        enableComposerGlow: true,
        enableDepthShadows: true,
        panelSidebarBg: 'rgba(15, 17, 24, 0.8)',
        panelChatBg: 'rgba(8, 9, 13, 0.6)',
        panelMembersBg: 'rgba(15, 17, 24, 0.8)',
        panelBackdropBlur: '24px',
    },
};
//# sourceMappingURL=premium.theme.js.map